class ArticleTOC {
  constructor() {
    this.tocNav = document.getElementById('article-toc-nav');
    this.articleContent = document.querySelector('.article-template-content');
    
    if (this.tocNav && this.articleContent) {
      this.init();
    }
  }

  init() {
    const headings = this.articleContent.querySelectorAll('h2, h3, h4');
    
    if (headings.length === 0) {
      // Verstecke TOC wenn keine Überschriften vorhanden
      const tocContainer = document.querySelector('.article-toc');
      if (tocContainer) tocContainer.style.display = 'none';
      return;
    }

    const tocList = this.buildTOC(headings);
    this.tocNav.appendChild(tocList);
  }

buildTOC(headings) {
  const ul = document.createElement('ul');
  ul.className = 'toc-list toc-list-level-2';
  
  let currentH2Li = null;
  let currentH2Ul = null;
  let currentH3Li = null;
  let currentH3Ul = null;

  headings.forEach((heading) => {
    const level = parseInt(heading.tagName.substring(1));
    const text = heading.textContent.trim();
    const id = this.generateId(text);
    
    // Setze ID auf die Überschrift
    heading.id = id;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = text;
    a.className = 'toc-link';
    li.appendChild(a);

    if (level === 2) {
      // H2 - Top Level
      ul.appendChild(li);
      currentH2Li = li;
      currentH2Ul = null;
      currentH3Li = null;
      currentH3Ul = null;
    } else if (level === 3) {
      // H3 - unter H2 oder direkt im Top Level wenn kein H2 existiert
      if (currentH2Li) {
        // Es gibt ein H2, also h3 darunter verschachteln
        if (!currentH2Ul) {
          currentH2Ul = document.createElement('ul');
          currentH2Ul.className = 'toc-list toc-list-level-3';
          currentH2Li.appendChild(currentH2Ul);
        }
        currentH2Ul.appendChild(li);
      } else {
        // Kein H2 vorhanden, h3 direkt in Top Level
        ul.appendChild(li);
      }
      currentH3Li = li;
      currentH3Ul = null;
    } else if (level === 4) {
      // H4 - unter H3, oder unter H2, oder direkt im Top Level
      if (currentH3Li) {
        // Es gibt ein H3, also h4 darunter verschachteln
        if (!currentH3Ul) {
          currentH3Ul = document.createElement('ul');
          currentH3Ul.className = 'toc-list toc-list-level-4';
          currentH3Li.appendChild(currentH3Ul);
        }
        currentH3Ul.appendChild(li);
      } else if (currentH2Li && currentH2Ul) {
        // Es gibt ein H2 aber kein H3, h4 unter H2
        currentH2Ul.appendChild(li);
      } else if (currentH2Li) {
        // Es gibt ein H2 aber noch keine UL, erstelle eine
        if (!currentH2Ul) {
          currentH2Ul = document.createElement('ul');
          currentH2Ul.className = 'toc-list toc-list-level-3';
          currentH2Li.appendChild(currentH2Ul);
        }
        currentH2Ul.appendChild(li);
      } else {
        // Kein H2 oder H3 vorhanden, h4 direkt in Top Level
        ul.appendChild(li);
      }
    }
  });

  return ul;
}

  generateId(text) {
    return text
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  }
}

// Initialisiere beim Laden
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ArticleTOC());
} else {
  new ArticleTOC();
}